import React, { createContext, useContext, useMemo } from 'react';
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';

// Create the context
export const ThemeContext = createContext({
  darkMode: false,
  toggleDarkMode: () => { },
});

// Custom hook to use the theme context
export const useThemeContext = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {

  // const [darkMode, setDarkMode] = useState(() => {
  //   const savedMode = localStorage.getItem('darkMode');
  //   return savedMode === 'true';
  // });

  // Fixed to always use light mode
  const darkMode = false;


  // useEffect(() => {
  //   localStorage.setItem('darkMode', darkMode);
  // }, [darkMode]);

  // DARK MODE COMMENTED OUT - Toggle function
  // const toggleDarkMode = () => {
  //   setDarkMode(prevMode => !prevMode);
  // };

  const toggleDarkMode = () => {
    // Dark mode toggle disabled
    console.log('Dark mode toggle is disabled');
  };

  // Create theme based on dark mode state
  const theme = useMemo(() => {
    return createTheme({
      palette: {
        mode: darkMode ? 'dark' : 'light',
        primary: {
          main: darkMode ? '#3a8eff' : '#0056D2',
        },
        secondary: {
          main: darkMode ? '#3f51b5' : '#264FDA',
          default: darkMode ? '#1e2738' : '#D0E2FF',
        },
        background: {
          main: darkMode ? '#121212' : '#F9F9FB',
          primary: darkMode ? '#1e1e1e' : '#f2f2f2',
          secondary: darkMode ? '#5c6a70' : '#7B878C',
          default: darkMode ? '#282828' : '#ffffff',
          paper: darkMode ? '#282828' : '#ffffff',
        },
        text: {
          primary: darkMode ? '#ffffff' : '#000000',
          secondary: darkMode ? '#b0b0b0' : '#4a4a4a',
          default: darkMode ? '#444444' : '#E8E8EE',
        },
      },
      components: {
        MuiTextField: {
          styleOverrides: {
            root: {
              '& .MuiOutlinedInput-root': {
                borderRadius: '1rem',
              },
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundColor: darkMode ? '#282828' : '#ffffff',
            },
          },
        },
        MuiTableHead: {
          styleOverrides: {
            root: {
              backgroundColor: darkMode ? '#1a1a1a' : '#F9F9FB',
            }
          }
        },
        MuiTableRow: {
          styleOverrides: {
            root: {
              '&:hover': {
                backgroundColor: darkMode ? '#333333' : '#f5f5f5',
              }
            }
          }
        }
      },
      typography: {
        fontFamily: '"Inter", "Roboto", "Open Sans", sans-serif',
        h1: {
          fontSize: '2rem',
          fontWeight: 500,
        },
        subtitle1: {
          fontSize: '1.2rem',
          fontWeight: 300,
          lineHeight: '2.25rem',
        },
        button: {
          fontSize: '1rem',
        },
      },
    });
  }, [darkMode]);

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

// Add PropTypes validation
ThemeProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
